
import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../common/Table";
import PageHeader from "../../common/PageHeader";
import fetchData from "../../../api/fetchApi";
import DatePickerModal from "../../common/DatePickerModal";

export default function AccountManagementPage() {
  // Helper to refresh user list
  const refreshAccounts = async () => {
    try {
      const data = await fetchData(`finance/accounts?page=${currentPage}&per_page=${perPage}`);
      setAccounts(data.data);
      setTotalAccounts(data.meta.total);
      setCurrentPage(data.meta.current_page);
      setTotalPages(data.meta.last_page);
    } catch (error) {
      console.error("Failed to fetch Accounts:", error);
    }
  };
  const dir = "rtl";
  const navigate = useNavigate();
  const [Accounts, setAccounts] = useState([]);
  const [totalAccounts, setTotalAccounts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    from: "يناير 2025",
    to: "يونيو 2025",
  });

  useEffect(() => {
    refreshAccounts();
  }, [currentPage, perPage]);

  const columns = useMemo(
    () => [
      { header: "المعرف", accessor: "id" },
        {
        header: "المالك",
        accessor: "owner",
        render: (row) => row.owner ? `${row.owner.name} (${row.owner_type?.split('\\').pop() || ''})` : "-",
      },
      {
        header: "الرصيد",
        accessor: "balance",
        render: (row) => `${row.balance} ${row.currency?.symbol || ''}`,
      },
     
      {
        header: "آخر معاملة",
        accessor: "last_transaction",
        render: (row) => row.last_transaction ? new Date(row.last_transaction).toLocaleString() : "-",
      },
      {
        header: "الوصف",
        accessor: "description",
        render: (row) => row.description || "-",
      },
      {
        header: "نشط؟",
        accessor: "is_active",
        render: (row) => (row.is_active ? "نعم" : "لا"),
      },
      {
        header: "نوع الحساب",
        accessor: "type",
        render: (row) => row.type,
      },
    
      // {
      //   header: "تاريخ الإنشاء",
      //   accessor: "created_at",
      //   render: (row) => row.created_at ? new Date(row.created_at).toLocaleString() : "-",
      // },
      // {
      //   header: "تاريخ التحديث",
      //   accessor: "updated_at",
      //   render: (row) => row.updated_at ? new Date(row.updated_at).toLocaleString() : "-",
      // },
    ],
    []
  );

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir={dir}>
      <DatePickerModal
        isOpen={isDatePickerOpen}
        onClose={() => setDatePickerOpen(false)}
      />
      {/* Top card: actions + total */}
      <PageHeader title="إجمالي الحسابات" total={totalAccounts} stats={[]}>
        {/* <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
          <span className="inline-block rotate-180">↕</span>
          من الاحدث إلى الأقدم
        </button>
        <button
          onClick={() => setDatePickerOpen(true)}
          className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="4" width="18" height="18" rx="2" stroke="#6b7280" />
            <line x1="8" y1="2" x2="8" y2="6" stroke="#6b7280" />
            <line x1="16" y1="2" x2="16" y2="6" stroke="#6b7280" />
            <line x1="3" y1="10" x2="21" y2="10" stroke="#6b7280" />
          </svg>
          {dateRange.from} · {dateRange.to}
        </button> */}
       
      </PageHeader>

      {/* Table card */}
      <div className="mt-5">
        <Table
          columns={columns}
          rows={Accounts}
         
          pagination={{
            title: "الحسابات",
            label: `الصفحة ${currentPage} من ${totalPages}`,
            pages: [1, 2, 3], // This should be made dynamic based on totalPages
            current: currentPage,
            last: totalPages,
            onPageChange: setCurrentPage,
            perPage: perPage,
            onPerPageChange: setPerPage,

            // onRowClick: (row) => navigate(`/admin/Accounts/${row.id}`),
            // onEdit, onStopPublish, onDelete can be passed here for row actions
          }}
          act={[
            {
              label: (
                <div className="flex items-center gap-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.33341 2.66646H4.80008C4.05334 2.66646 3.67998 2.66646 3.39476 2.81179C3.14388 2.93962 2.9399 3.14359 2.81207 3.39448C2.66675 3.67969 2.66675 4.05306 2.66675 4.7998V11.1998C2.66675 11.9465 2.66675 12.3199 2.81207 12.6051C2.9399 12.856 3.14388 13.06 3.39476 13.1878C3.67998 13.3331 4.05334 13.3331 4.80008 13.3331H11.2001C11.9468 13.3331 12.3202 13.3331 12.6054 13.1878C12.8563 13.06 13.0603 12.856 13.1881 12.6051C13.3334 12.3199 13.3334 11.9465 13.3334 11.1998V8.33313M10.3334 3.66646L12.219 5.55208M7.17524 6.82464L11.6074 2.39248C12.1281 1.87178 12.9723 1.87178 13.493 2.39248C14.0137 2.91318 14.0137 3.7574 13.493 4.27809L8.91837 8.85274C8.41061 9.3605 8.15673 9.61438 7.86755 9.81629C7.61087 9.9955 7.33403 10.144 7.04273 10.2586C6.71455 10.3878 6.3626 10.4588 5.6587 10.6008L5.33342 10.6665L5.36505 10.445C5.47699 9.66144 5.53296 9.26965 5.66027 8.90387C5.77325 8.5793 5.92758 8.27063 6.11946 7.98551C6.33569 7.66419 6.61554 7.38434 7.17524 6.82464Z"
                      stroke="#1A6AB3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  <p className="text-[#1A6AB3]">تعديل</p>
                </div>
              ),
              onClick: (row) => navigate(`/admin/Accounts/${row.id}/edit`),
            },
           
           {
              label: (
                <div className="flex items-center gap-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.66675 8.00008C2.66675 5.05408 4.72075 2.99992 7.66675 2.99992C10.6127 2.99992 12.6667 5.05408 12.6667 8.00008C12.6667 10.9461 10.6127 12.9999 7.66675 12.9999C4.72075 12.9999 2.66675 10.9461 2.66675 8.00008Z"
                      stroke="#4de024"
                      stroke-linecap="round"
                      stroke-line
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.3333 4.66675L14.6666 3.33341"
                      stroke="#4de024"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                
                  <p className="text-[#4de024]">
                    حوالات
                    </p>
                </div>
              ),
              onClick:  (row) => { navigate(row.id + '/transactions')
                
              },
            },

            {
              label: (
                <div className="flex items-center gap-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6667 3.33325H11.3334L10.6667 2.66659H5.33341L4.66675 3.33325H1.33341M12.6667 3.33325V12.6666C12.6667 13.1199 12.5261 13.5559 12.2192 13.8628C11.9123 14.1697 11.4763 14.3103 11.0231 14.3103H4.97608C4.52285 14.3103 4.08686 14.1697 3.77996 13.8628C3.47307 13.5559 3.33241 13.1199 3.33241 12.6666V3.33325H12.6667Z"
                      stroke="#E02424"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.66675 7.33325V11.3333"
                      stroke="#E02424"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.33325 7.33325V11.3333"
                      stroke="#E02424"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p className="text-[#E02424]">حذف م</p>
                </div>
              ),
              onClick: async (row) => {
                try {
                  await fetchData(`finance/accounts/${row.id}`, "DELETE");
                  await refreshAccounts();
                } catch (error) {
                  // Optionally show error
                  console.error("Failed to delete account:", error);
                }
              },
            },

          ]}
        />
      </div>
    </div>
  );
}
